import { createFileRoute } from "@tanstack/react-router";
import { MainSidebar } from "../../components/sidebars/MainSidebar";
import { UsersPage } from "./-UsersPage";

function UsersPageWithSidebar() {
  return (
    <div className="flex h-screen">
      <MainSidebar />
      <div className="flex-1 overflow-auto">
        <UsersPage />
      </div>
    </div>
  );
}

export const Route = createFileRoute("/admin/users")({
  component: UsersPageWithSidebar,
});
